// src/Components/Pages/Contact.jsx
import { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Create mailto link
    const subject = encodeURIComponent(`Contact from ${formData.name}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\n` +
      `Email: ${formData.email}\n\n` +
      `Message:\n${formData.message}`
    );
    
    // Open default email client
    window.location.href = `mailto:info@risingtogreatness.org?subject=${subject}&body=${body}`;
    
    // Optional: Show a message
    alert('Your email client will open. Please send the email to complete your message.');
    
    // Clear form
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <div className="bg-gray-50 min-h-screen px-4 sm:px-6 md:px-16 py-12 sm:py-16">
      
      {/* HEADER */}
      <div className="max-w-3xl mx-auto text-center mb-12">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-primaryBlue mb-4">
          Contact Us
        </h1>
        <p className="text-gray-700 text-sm sm:text-base">
          We'd love to hear from you! Fill out the form below or reach us through any of our contact channels.
        </p>
      </div>

      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">

        {/* CONTACT INFO */}
        <div className="bg-white rounded-xl p-6 shadow-md">
          <h2 className="text-2xl font-bold text-primaryBlue mb-6">Our Contact Info</h2>
          <div className="space-y-4 text-gray-700">
            <p className="flex items-center gap-2">
              <span className="font-semibold">Email:</span> 
              <a href="mailto:info@risingtogreatness.org" className="text-primaryBlue hover:underline">
                info@risingtogreatness.org
              </a>
            </p>
            <p className="flex items-center gap-2">
              <span className="font-semibold">Phone:</span> 
              <a href="tel:+254112503303" className="text-primaryBlue hover:underline">
                +254140014842
              </a>
            </p>
            <p className="flex items-center gap-2">
              <span className="font-semibold">Location:</span> Amalemba Stage, Off Kakamega Airstrip
            </p>
          </div>
        </div>

        {/* CONTACT FORM */}
        <form onSubmit={handleSubmit} className="bg-white rounded-xl p-6 shadow-md space-y-4">
          <h2 className="text-2xl font-bold text-primaryBlue mb-4">Send a Message</h2>

          <div>
            <label className="block text-gray-700 font-medium mb-1" htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              required
              className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-primaryGold focus:border-primaryGold outline-none transition"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1" htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="you@example.com"
              required
              className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-primaryGold focus:border-primaryGold outline-none transition"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1" htmlFor="message">Message</label>
            <textarea
              id="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your message..."
              required
              className="w-full border border-gray-300 rounded-md px-4 py-2 focus:ring-2 focus:ring-primaryGold focus:border-primaryGold outline-none transition resize-none"
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full bg-primaryBlue text-white font-semibold py-2 rounded-md hover:bg-primaryGold transition"
          >
            Send Message
          </button>
          
          <p className="text-xs text-gray-500 text-center mt-2">
            This will open your default email app. Please send the email to complete your message.
          </p>
        </form>

      </div>
    </div>
  );
}

export default Contact;